module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/35c6867250ec4f430624bc9e2e7072d7.svg";